// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-wrapper":"styles__view-slider-item-wrapper__2OF9C","viewSliderItemWrapper":"styles__view-slider-item-wrapper__2OF9C"};